import {
  FormControl,
  Grid,
  InputLabel,
  ListSubheader,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import React from 'react'

const AccessComplications = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={8}>
    <TextField
      fullWidth
      autoComplete="off"
      label="Complications"
      onChange={(e) =>
        setModuleValues((prev) => ({
          ...prev,
          ['Complications']: e.target.value,
        }))
      }
    />
  </Grid>
)

export default AccessComplications
